var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.visible,
        "before-close": _vm.handleCancel,
        "destroy-on-close": true,
        width: "480px"
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.ruleForm,
            "status-icon": "",
            rules: _vm.rules,
            "label-width": "100px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "项目编号", prop: "projectCode" } },
            [
              _c("el-input", {
                attrs: { autocomplete: "off" },
                model: {
                  value: _vm.ruleForm.projectCode,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "projectCode", $$v)
                  },
                  expression: "ruleForm.projectCode"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "项目名称", prop: "projectName" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.ruleForm.projectName,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "projectName", $$v)
                  },
                  expression: "ruleForm.projectName"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "所在区县", prop: "areas" } },
            [
              _c("el-cascader", {
                ref: "cascaders",
                staticClass: "custome-popper-class",
                staticStyle: { width: "100%" },
                attrs: {
                  placeholder: "请输入或选择中国区域",
                  props: _vm.props,
                  options: _vm.regionList,
                  filterable: ""
                },
                on: { change: _vm.handleCasChange },
                model: {
                  value: _vm.place,
                  callback: function($$v) {
                    _vm.place = $$v
                  },
                  expression: "place"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("el-button", { on: { click: _vm.handleCancel } }, [
            _vm._v("取消")
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.handleOk }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }